import { render, staticRenderFns } from "./new-item-supplier-form.vue?vue&type=template&id=78c877a1&scoped=true&"
import script from "./new-item-supplier-form.vue?vue&type=script&lang=js&"
export * from "./new-item-supplier-form.vue?vue&type=script&lang=js&"
import style0 from "./new-item-supplier-form.vue?vue&type=style&index=0&id=78c877a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c877a1",
  null
  
)

export default component.exports